<template>
    <div class="login-container">
      <v-card width="350px" class="login-card">
          <v-container class="left-login-form text-center">
            <img src="img/logo.png" alt="" width="50">
            <h3 class="text-center">SIGN IN</h3>
            <v-form
                ref="form"
                lazy-validation
                v-model="valid"
            >
                <v-text-field
                v-model="email"
                label="Email"
                required
                 :rules="emailRules"
                prepend-icon="email"
                @keydown.enter="login()"
                ></v-text-field>
                <v-text-field
                v-model="password"
                type="password"
                label="Password"
                prepend-icon="lock"
                required
                @keydown.enter="login()"

                ></v-text-field>
                <br>
                <v-btn
                :disabled="!valid"
                :color="color"
                class="mr-4 white--text"
                rounded
                block
                :loading="loading"
                @click="login"
                >
                Log-in
                </v-btn>
            </v-form>
          </v-container>

          <v-container class="right-login-form text-center">
            <h3 class="text-center"></h3>
            <h4 class="text-center"></h4>
            <img src="img/login_bg.svg" alt="" style="width:100%;opacity:0.5">
          </v-container>
      </v-card>
    </div>
</template>
<script>
import {mapActions,mapGetters} from 'vuex'
import store from '../stores'
import axios from 'axios'

export default {
    name: 'Login',
     data: () => ({
      valid: false,
      password: '',
      nameRules: [
        v => !!v || 'Password is required',

      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      loading:false
    }),

    methods : {
        ...mapActions({
            setAuth:'auth/setAuth',
            setSnakbar:'snakbar/setSnakbar'
        }),

        async login(){
            this.loading = true
            let data = new FormData()
            data.append('email',this.email)
            data.append('password',this.password)
            await this.axios.post('/login',data)
            .then((ress) => {
                console.log(ress)
                this.setAuth({
                    user: ress.data.user,
                    token : ress.data.access_token,
                    menu : ress.data.menu
                })
                localStorage.setItem('token', this.token);
                this.$router.push('/dashboard')
            })
            .catch((err) =>{
                this.setSnakbar({
                    color_snakbar:'red',
                    pesan : 'Email atau Password salah',
                    status : true
                })
            })
            this.loading = false

        }
    },
    computed: {
        ...mapGetters({
            user:'auth/user',
            menu: 'auth/menu',
            token : 'auth/token',
            beforeUrl : 'BeforeUrl/url',
            color: 'color/color'
        })
    },
    async beforeRouteEnter(to, from, next){
        // console.log(to)
        // console.log(from)
        // console.log(next)
        let token = localStorage.getItem('token')

        console.log(token)
        let config = {
            headers: {
            'Authorization': 'Bearer ' + token,
            }
        }
        if (token) {
        await axios.get('/api/me',config)
            .then((ress) =>{
                store.dispatch('auth/setAuth',{
                    user: ress.data.user,
                    token : ress.data.access_token,
                    menu : ress.data.menu
                })
                next('login')
            }
                )
            .catch((err) =>console.log(err))
        }
        next()
    },
//    async beforeMount(){
//        let token = localStorage.token
//        if (token) {
//            let config = {
//                 headers: {
//                 'Authorization': 'Bearer ' + token,
//                 }
//             }
//             await this.axios.get('/me',config)
//                 .then((ress) =>{
//                     console.log(ress.data)
//                 }
//                     )
//                 .catch((err) =>console.log(err))
//        }
//     }

}
</script>

<style lang="css" scoped>
.v-main {
  background-color: #4c8dff !important;
}
.login-container {
  height:550px; display:flex; justify-content: center;align-items: center;
}
 .login-card{
   margin: auto;
   padding: 20px;
 }
</style>

